export const scrollToCheckout = () => {
  const element = document.getElementById('comprar')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
